export default {
  message: {
    hello: 'Hello World'
  },
}
